import React from "react";
import "./Header.css";

const Header = ({ inQuestionnaire, questionsNum, questionsDone }) => {
  return (
    <div>
      <div className="header_container">
        <div className={"logo_img_header " + (inQuestionnaire ? " logo_in_quest logo_in_scnd_step" : "")}></div>
        {inQuestionnaire && (
          <div className="in_scnd_side_step_container">
            <div className="side_step_progress">
              <div className="side_step_fill" style={{ width: (questionsDone / questionsNum) * 100 + "%" }}></div>
            </div>
            {questionsDone}/{questionsNum} Steps
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
